/**
 * Resolve a catalog asset path (sportsbook / sport logo) to a fetchable URL.
 *
 * Two shapes live in `logo_url` today:
 *   - relative `/sportsbooks/<file>` or `/leagues/<file>` — static tiles
 *     committed to the repo and served by widget-assets behind the API host;
 *   - absolute `https://…supabase.co/storage/v1/object/public/brand-logos/…`
 *     — tiles uploaded from the portal (migration 0066). Pass through as-is.
 */
export function resolveAssetUrl(apiBase: string, path: string | null | undefined): string | undefined {
  if (!path)
    return undefined
  return /^https?:\/\//i.test(path) ? path : `${apiBase}${path}`
}
